import SecureLS from "secure-ls";

export var URL = {
    BACKEND_URL: "https://pms-api.apmiindia.org/pms",
    IDM_BACKEND_URL:  "https://pmsidm-api.apmiindia.org/pmsidm",
    // IDM_BACKEND_URL:  "https://pmsidmdev-api.kfintech.com/pmsidm",
    FORGOT_PASSWORD_URL: process.env.REACT_APP_FORGOT_PASSWORD_URL
 
};

export var KEY = {
    ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY,
    IDM_ENCRYPTION_KEY: process.env.REACT_APP_IDM_ENCRYPTION_KEY,
    BUCKET: process.env.REACT_APP_BUCKET
}

export var ls = new SecureLS({
    encodingType: "aes",
    isCompression: false,
    encryptionSecret: process.env.REACT_APP_localStorageEncryptionKey
});

export const Year = [
    { label: "2024-25", value: "2024-25" },
    { label: "2025-26", value: "2025-26" },
];

export const Quarter = [
    { value: "Q1", label: "Q1" },
    { value: "Q2", label: "Q2" },
    { value: "Q3", label: "Q3" },
    { value: "Q4", label: "Q4" },
];

export const HalfYear = [
    { value: "H1", label: "H1" },
    { value: "H2", label: "H2" },
];

export const ReportType = [
    {value: "ALERT", label: "ALERT"},
]

export const actionsOptions = [
    { label: 'No Action', value: 'No Action' },
    { label: 'Deficiency', value: 'Deficiency' },
    { label: 'Warning', value: 'Warning' },
    { label: 'Advisory', value: 'Advisory' },
    { label: 'No SID Processing', value: 'No SID Processing' },
    { label: 'Adjudication', value: 'Adjudication' },
    { label: 'Enquiry', value: 'Enquiry' },
    { label: '11B Proceedings', value: '11B Proceedings' },
    // { label: 'Seek Explaination', value: 'Seek Explaination' }
  ];;

export const accessibleRoutes = {
    PMS: [
      "/app/welcome",
      "/app/profile",
      "/app/tracker",
      "/app/trackerView",
      "/app/upload",
      "/app/takeAction",
      "/app/takeActionSettlement",
      "/app/cmmPage",
      "/app/cmmTracker",
      "/app/cmmView",
      "/app/cmmLayout",
      
    ],
    SEBI: [
      "/app/profile",
      "/app/welcome",
      "/app/sebiTracker",
      "/app/uploadutilityAlert",
      "/app/sebiTrackerView",
      "/app/Analytics",
      "/app/Reports",
      "/app/generalModule",
      "/app/sebiCmmTracker",
      
    ],
  };

